import { render } from "./SuperAdminDatatableTDPaymentStatus.vue?vue&type=template&id=616edd63"
import script from "./SuperAdminDatatableTDPaymentStatus.vue?vue&type=script&lang=js"
export * from "./SuperAdminDatatableTDPaymentStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__